export default {"src":"https://fishbrain.com/_next/static/media/fish.ed6da771.svg","height":513,"width":513,"blurWidth":0,"blurHeight":0};